import "./styles.less";

import {
	Button,
	Form,
	Input,
	Modal,
	Space,
	Tooltip,
	Typography,
	message,
} from "antd";
import {
	CheckOutlined,
	CopyOutlined,
	FacebookFilled,
	PrinterFilled,
	ShareAltOutlined,
	TwitterSquareFilled,
	WhatsAppOutlined,
	YoutubeFilled,
} from "@ant-design/icons";
import React, { useContext, useEffect, useState } from "react";

import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { PropComponentMode } from "../PropertyInterfaces";
import { Rule } from "antd/lib/form";
import { useRouter } from "next/router";
import { useSocialShare } from "./hook";
import { useUser } from "../../User/User.hook";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { CloseButton } from "shared-components/Components/CustomIcons/CloseButton/web";

const { Title } = Typography;

const socialMediaIcons = Object.freeze({
	YouTube: <YoutubeFilled />,
	Facebook: <FacebookFilled />,
	Twitter: <TwitterSquareFilled />,
	WhatsApp: <WhatsAppOutlined />,
	Copy: <CopyOutlined />,
	Check: <CheckOutlined />,
	Print: <PrinterFilled />,
});

export function SocialShare({
	id,
	mode = "auto",
	isEspecial,
	isDisabledProperty = false,
}: {
	id: any;
	mode?: PropComponentMode;
	isEspecial?: Boolean;
	isDisabledProperty?: boolean;
}) {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const {
		loading,
		error,
		socialMediaLink,
		shareByEmail: { share, loading: shareLoading, data: shareData },
	} = useSocialShare({ id, mode });

	const { isLoggedIn, user } = useUser();
	const { asPath } = useRouter();
	const { site_name } = useContext(ConfigStateContext);
	// const GA = useGoogleAnalytics();

	const [modal, setModal] = useState(false);
	const [form] = Form.useForm();

	const triggerGAevent = (action: string, label: string) => {
		// GA.Event({
		// 	category: 'user_event',
		// 	action: action,
		// 	label: label
		// })
	}

	const onCreate = values => {
		share(values)
			.then(data => {
				const description = "La propiedad ha sido compartida exitosamente. Le enviamos esta propiedad a " + values.other;
				handleClickShowNotification({
					message: "Propiedad Compartida",
					description,
				});
			})
			.catch(data => {
				handleClickShowNotification({
					message: "Ha ocurrido un error",
					description: "Ocurrió un error compartiendo esta propiedad",
					type: "error",
				});
			});

		triggerGAevent('share_prop_by_email', '');
		setModal(false);
	};

	useEffect(() => {
		if (isLoggedIn) form.setFieldsValue({ me: user.data?.me.email });
	}, [isLoggedIn, user]);

	const emailRules: Rule[] = [
		{ required: true, message: "Ingrese el correo electrónico." },
		{ type: "email", message: "Ingrese un correo válido." },
	];

	const CollectionCreateForm = ({ visible, onCreate, onCancel }) => {
		return (
			<Modal
				className="social-share-modal"
				visible={visible}
				footer={null}
				closeIcon={<CloseButton />}
				onCancel={onCancel}
				title="Compartir Propiedad"
				centered
				width="100%">
				<Form
					onFinish={onCreate}
					requiredMark={false}
					form={form}
					layout="vertical"
					name="form_in_modal"
					scrollToFirstError>
					{/* <Form.Item
						name="other"
						label="Comparte esta propiedad con: "
						rules={emailRules}>
						<Input placeholder="Correo electrónico" />
					</Form.Item>
					<Form.Item name="me" label="Ingresá tu correo electrónico: " rules={emailRules}>
						<Input placeholder="Tu correo electrónico" />
					</Form.Item>
					<Space>
						<Form.Item>
							<Button onClick={() => setModal(false)}>Cancelar</Button>
						</Form.Item>
						<Form.Item>
							<Button
								type="primary"
								loading={loading && shareLoading}
								htmlType="submit">
								Compartir
							</Button>
						</Form.Item>
					</Space> */}
					<Form.Item className="social-share-networks">
						{/* <Title level={4}>O también puedes compartir en: </Title> */}
						{socialMediaLink && (
							<Space>
								<Tooltip title="Facebook">
									<Button
										className="secondary"
										onClick={() => { triggerGAevent('share_prop_on_social_media', 'Facebook') }}
										href={`https://www.facebook.com/sharer/sharer.php?u=${socialMediaLink}`}
										target={"_blank"}
										icon={socialMediaIcons.Facebook}
									/>
								</Tooltip>
								<Tooltip title="Twitter">
									<Button
										className="secondary"
										onClick={() => { triggerGAevent('share_prop_on_social_media', 'Twitter') }}
										href={`https://twitter.com/intent/tweet?text=${encodeURI(
											`Mira esta propiedad de ${site_name}`
										)}&url=${socialMediaLink}&hashtags=${site_name},${"Propiedad"}`}
										target={"_blank"}
										icon={socialMediaIcons.Twitter}
									/>
								</Tooltip>
								<Tooltip title="WhatsApp">
									<Button
										className="secondary"
										onClick={() => { triggerGAevent('share_prop_on_social_media', 'WhatsApp') }}
										href={`https://wa.me/?text=${encodeURI(
											`Mira esta propiedad de ${site_name}: \n${socialMediaLink}`
										)}`}
										target={"_blank"}
										icon={socialMediaIcons.WhatsApp}
									/>
								</Tooltip>
								{mode != "project" && (
									<Button
										className="secondary"
										href={`${asPath}?imprimir`}
										target={"_blank"}
										icon={socialMediaIcons.Print}
									/>
								)}
								<Button
									className="secondary"
									onClick={() => {
										if (typeof navigator.clipboard !== "undefined") {
											navigator.clipboard
												.writeText(socialMediaLink)
												.then(() => {
													message.success({
														icon: socialMediaIcons.Check,
														content: "¡Copiado!",
													});
												});
										} else {
											const el = document.createElement("textarea");
											el.value = socialMediaLink;
											document.body.appendChild(el);
											el.select();
											document.execCommand("copy");
											document.body.removeChild(el);
										}
										triggerGAevent('share_prop_on_social_media', 'copy_link')
									}}
									icon={socialMediaIcons.Copy}
								/>
							</Space>
						)}
					</Form.Item>
				</Form>
			</Modal>
		);
	};

	return (
		<div>
			<Button
				disabled={loading || isDisabledProperty}
				className={`social-share-button secondary ${isEspecial ? "isEspecial" : ""}`}
				onClick={e => {
					e.stopPropagation();
					setModal(true);
					triggerGAevent('share_popup_open', '');
				}}
				icon={<ShareAltOutlined className="social-share-icon" />}>
				{!isEspecial ? "Compartir" : null}
			</Button>
			<CollectionCreateForm
				visible={modal}
				onCreate={onCreate}
				onCancel={() => setModal(false)}
			/>
		</div>
	);
}
